import header from "./architecture.jpg";
import section1 from "./lamp-armchair-wooden-floor.jpg";
import section2 from "./living-room-with-staircase.webp";
import section3 from "./dachgeschoss.jpg";
import section4 from "./spacious-room-with-various-areas.jpg";
import section5 from "./room-with-table-chairs.jpg";
import section6 from "./attic-apartment-modern-living-room.jpg";
import section7 from "./attic-built-in-furniture.webp";
import section8 from "./interior-church.jpg";


export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
};
